import Image from 'app/Components/Shared/Image/image';
import React, {useState} from 'react';
import {Input} from 'reactstrap';
import './InputWithActions.scss';

const InputWithActions = (props) => {
  // Extract custom props that shouldn't be passed to the DOM element
  const {actionText, onAction, onClear, actionDisabled, hideClearButton, error, required, ...inputProps} = props;

  const handleActionClick = () => {
    if (onAction && !actionDisabled) {
      onAction(props.value);
    }
  };

  const handleClearClick = () => {
    if (onClear) {
      onClear();
    }
  };

  const handleChange = (e) => {
    props.onChange(e);
  };

  return (
    <div className='input-with-actions'>
      <label className={`input-with-actions-float-${required ? 'label-required' : 'label'}`}>
        <Input
          disabled={props.disabled}
          name={props.name}
          value={props.value}
          onChange={handleChange}
          placeholder={props.placeholder}
          type={props.type || 'text'}
          {...inputProps}
        />
        {/* Clear (X) Button */}
        {!hideClearButton && (
          <button type='button' className='clear-button' onClick={handleClearClick} aria-label='Clear input'>
            <Image src={require('./Icons/close.svg')} alt='clear' />
          </button>
        )}
        <span className='placeholder'>{props.placeholder}</span>
        {/* Action Button */}
        {actionText && (
          <div className={`action-button ${actionDisabled ? 'disabled' : ''}`} onClick={handleActionClick}>
            {actionText}
          </div>
        )}
      </label>
    </div>
  );
};

export default InputWithActions;
